(function() { window.GUID_c6fc40fb_d8bc_492f_a1b7_d0750829dd40 = { getGuid: function() { return "c6fc40fb-d8bc-492f-a1b7-d0750829dd40"; } }; })();
var CS;
(function (CS) {
    let Ajax;
    (function (Ajax) {
        let AjaxState;
        (function (AjaxState) {
            AjaxState[AjaxState["Start"] = 0] = "Start";
            AjaxState[AjaxState["Succeed"] = 1] = "Succeed";
            AjaxState[AjaxState["SmartScriptsExecuted"] = 2] = "SmartScriptsExecuted";
            AjaxState[AjaxState["Error"] = 3] = "Error";
            AjaxState[AjaxState["CallEnded"] = 4] = "CallEnded";
            AjaxState[AjaxState["PageContentReplaced"] = 5] = "PageContentReplaced";
            AjaxState[AjaxState["Aborted"] = 6] = "Aborted";
        })(AjaxState = Ajax.AjaxState || (Ajax.AjaxState = {}));
        //Permet de remplacer ajaxStart, ajaxStop, ajaxError qui dans des cas précis arrêtaient de fonctionner comme exemple certaines erreur avec le call ajax lui meme
        let AjaxListener;
        (function (AjaxListener) {
            let ajaxListeners;
            function OnAjaxStateChange(delegate) {
                if (!ajaxListeners) {
                    ajaxListeners = new Array();
                }
                ajaxListeners.push(delegate);
                return delegate;
            }
            AjaxListener.OnAjaxStateChange = OnAjaxStateChange;
            function NotifyAjaxStateChanged(state, extraParams, url) {
                if (ajaxListeners) {
                    for (var i = 0; i < ajaxListeners.length; i++) {
                        ajaxListeners[i](state, extraParams, url);
                    }
                }
            }
            AjaxListener.NotifyAjaxStateChanged = NotifyAjaxStateChanged;
            function Remove(delegate) {
                let index = ajaxListeners.indexOf(delegate);
                if (index > -1) {
                    ajaxListeners.splice(index, 1);
                }
            }
            AjaxListener.Remove = Remove;
        })(AjaxListener = Ajax.AjaxListener || (Ajax.AjaxListener = {}));
    })(Ajax = CS.Ajax || (CS.Ajax = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-ajax-listener.pre.js.map
